import React, { useEffect } from 'react';

const RecaptchaScriptLoader = () => {
    useEffect(() => {
        // 檢查是否已經加載過
        if (document.getElementById('recaptcha-script')) return;

        // 確保 CSP 政策在加載 reCAPTCHA 之前設置
        const existingCSPMeta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
        if (existingCSPMeta) {
            (existingCSPMeta as HTMLMetaElement).content += " https://www.gstatic.com"; // 更新現有的 CSP 設置
        } else {
            const cspMeta = document.createElement('meta') as HTMLMetaElement;
            cspMeta.httpEquiv = "Content-Security-Policy";
            cspMeta.content = "script-src 'self' https://www.google.com https://www.gstatic.com https://www.googletagmanager.com https://www.google.com https://www.gstatic.com ";
            document.head.appendChild(cspMeta); // 在頭部插入 CSP meta 標籤
        }

        // 動態創建 reCAPTCHA 腳本標籤
        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=6LfeWokqAAAAACKFe67YIKiyYmWq1tqR8yrFM8T3';
        script.id = 'recaptcha-script';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);

        // 腳本加載完成後的回調函數
        script.onload = () => {
            console.log('reCAPTCHA script loaded');
        };
    }, []);

    return null; // 這個組件不需要渲染任何東西
};

export default RecaptchaScriptLoader;